import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="text-xl font-bold text-background-50">汗汗漫画</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              更新最快的漫画网，提供好看的免费漫画大全，无遮挡韩漫日漫国漫，极速更新，永久免费。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">
                首页
              </Link>
              <Link to="/category/all" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">
                全部分类
              </Link>
              <Link to="/category/hanman" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">
                韩漫专区
              </Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              热门分类
            </h4>
            <div className="flex flex-wrap gap-2">
              {categories.slice(1, 7).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-xs px-3 py-1.5 rounded-full bg-background-800 text-background-300 hover:bg-background-700 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              联系方式
            </h4>
            <p className="text-sm text-background-400 mb-2">邮箱：contact@hanhanmanhua.com</p>
            <p className="text-sm text-background-400 mb-2">微信：hanhanmanhua</p>
            <p className="text-sm text-background-400">微博：@汗汗漫画官方</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 汗汗漫画 hanhanmanhua.com — 更新最快的免费漫画网
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}